module.exports = __webpack_public_path__ + "static/media/GO_P_enriched_terms.af4ee19a.zip";